export default {
	addAiMonitoring: 'bulk_add_ai_monitoring',
	delete: 'bulk_delete',
	invite: 'bulk_invite',
	removeAiMonitoring: 'bulk_remove_ai_monitoring',
	tag: 'bulk_tag',
};
